import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Header } from '../../components/Header';
import { SideBar } from '../../components/SideBar';
import { ContentContainer } from '../../components/ContentContainer';
import { Outlet } from 'react-router';
import { BODY_COLOR } from '../../constants';
import { PageContainer } from '../../components/PageContainer';
import { NotificationLiveUpdates } from '../../components/NotificationLiveUpdates';
import { PermissionsLiveUpdates } from '../../components/PermissionsLiveUpdates';
import { DevelopmentModeRouteGuard } from '@routes/DevelopmentModeRouteGuard';

export const MainLayout: React.FC = (): JSX.Element => {
  const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);

  return (
    <Box
      sx={{
        backgroundColor: BODY_COLOR, // TODO: change to theme color.
        minHeight: '100vh',
        borderBottom: `1px solid ${BODY_COLOR}`,
      }}
    >
      <NotificationLiveUpdates />
      <PermissionsLiveUpdates />
      <DevelopmentModeRouteGuard />
      <Header onMobileMenuToggle={() => setShowMobileMenu(!showMobileMenu)} />
      <PageContainer>
        <SideBar
          open={showMobileMenu}
          onClose={() => setShowMobileMenu(false)}
        />
        <ContentContainer>
          <Outlet />
        </ContentContainer>
      </PageContainer>
    </Box>
  );
};
